// components/settings/ui/SettingsRow.jsx
// A single settings row with a label, optional sublabel,
// and a right-side control (toggle, select, button, badge, etc.)
// or a clickable chevron arrow for navigation rows.

import styles from "./SettingsRow.module.css";

const ChevronIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9 18l6-6-6-6" />
  </svg>
);

export default function SettingsRow({
  label,      // required  — main row label
  sublabel,   // optional  — secondary description line
  children,   // optional  — right-side control (Toggle, Select, Badge, Button…)
  onClick,    // optional  — makes the whole row clickable (shows chevron)
  danger,     // optional  — renders label in red
  noBorder,   // optional  — removes the bottom divider
}) {
  const isClickable = !!onClick && !children;

  return (
    <div
      className={[
        styles.row,
        noBorder    ? styles.noBorder   : "",
        isClickable ? styles.clickable  : "",
      ].join(" ")}
      onClick={isClickable ? onClick : undefined}
    >
      {/* Left: label + sublabel */}
      <div className={styles.text}>
        <span className={`${styles.label} ${danger ? styles.danger : ""}`}>
          {label}
        </span>
        {sublabel && <span className={styles.sublabel}>{sublabel}</span>}
      </div>

      {/* Right: custom control OR chevron */}
      {children && <div className={styles.control}>{children}</div>}
      {isClickable && (
        <span className={styles.chevron}>
          <ChevronIcon />
        </span>
      )}
    </div>
  );
}